if (!customElements.get('header-menu')) {
  class HeaderMenu extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.addDelegatedEventListeners();
		}

		addDelegatedEventListeners() {
			this.addEventListener('click', (e) => {
				const clickedElement = e.target.closest('[data-action]');
				if (!clickedElement) return;

				const mobileDrawer = this.querySelector('[data-mobile-drawer]');
				const logo = this.querySelector('[data-logo]');
				const {
					action
				} = clickedElement.dataset;
				
				switch (action) {
					case 'close-menu':
						mobileDrawer.classList.add('-translate-x-full', 'invisible');
						logo.classList.remove('active');
						document.querySelector('body').classList.remove('overflow-hidden');
						document.querySelector('[data-action="open-menu"]').focus();
						break;
					case 'open-menu':
						mobileDrawer.classList.remove('-translate-x-full', 'invisible');
						document.querySelector('body').classList.add('overflow-hidden');
						logo.classList.add('active');
						mobileDrawer.querySelector('[data-action="close-menu"]').focus();
						break;
					default: break;
				}
			});
			if (this.closest('.banner')) {
				const dataColorText = this.querySelectorAll('[data-color-change]');
				window.addEventListener('scroll', () => {
					if (window.pageYOffset > this.offsetHeight) {
						dataColorText.forEach((el) => {el.style.color = 'var(--primary-dark)'});
						document.documentElement.style.setProperty('--header-bg', 'var(--header-bg-initial)');
						document.documentElement.style.setProperty('--header-shadow', '0 2px 4px 0 rgb(0 0 0 / 2%), 0 2px 10px 0 rgb(0 0 0 / 3%)');
						this.querySelector('nav')?.classList.replace('before:backdrop-blur-none', 'before:backdrop-blur-xl');
						return;
					}
					dataColorText.forEach((el) => {el.removeAttribute('style')});
					document.documentElement.style.setProperty('--header-bg', 'transparent');
					document.documentElement.style.setProperty('--header-shadow', '0');
					this.querySelector('nav')?.classList.replace('before:backdrop-blur-xl', 'before:backdrop-blur-none');

				}, { passive: true })
				this.addEventListener('mouseenter', () => {
					//if (window.matchMedia('(max-width: 768px)')) return;
					dataColorText.forEach((el) => {el.style.color = 'var(--primary-dark)'});
				});
				this.addEventListener('mouseleave', () => {
					if (window.pageYOffset > this.offsetHeight) {
						//if (window.matchMedia('(min-width: 768px)')) return;
						dataColorText.forEach((el) => {el.style.color = 'var(--primary-dark)'});
						return;
					}
					dataColorText.forEach((el) => {el.removeAttribute('style')});
				})
			} else {
				window.addEventListener('scroll', () => {
					if (window.pageYOffset > 0) {
						document.documentElement.style.setProperty('--header-shadow', '0 2px 4px 0 rgb(0 0 0 / 2%), 0 2px 10px 0 rgb(0 0 0 / 3%)');
						this.querySelector('nav')?.classList.replace('before:backdrop-blur-none', 'before:backdrop-blur-xl');
					} else {
						document.documentElement.style.setProperty('--header-shadow', '0');
						this.querySelector('nav')?.classList.replace('before:backdrop-blur-xl', 'before:backdrop-blur-none');
					}
				})
			}
		}
  }
	customElements.define('header-menu', HeaderMenu);
}